import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { HomeownerTooltip } from './HomeownerTooltip';

app.component('homeownerTooltip', react2angular(HomeownerTooltip, ['isOpen', 'close'], []));
